import React, { useState, useEffect, useContext, useRef } from 'react'
import { Link, useParams, useNavigate } from 'react-router-dom'
import { AuthContext } from '../../App.js'
import { Button, TextField, Table, TableHead, TableBody, TableRow, TableCell, IconButton, InputAdornment, makeStyles, useMediaQuery } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import { useSwipeable } from 'react-swipeable'
import './index.css'
import Header from '../Header'
import ModalAddArticle from '../ModalAddArticle'
import ModalLogoutAlert from '../ModalLogoutAlert'
import Loading from '../LoadingComponent'
import { ReactComponent as Search } from '../../assets/search.svg'
import { ReactComponent as Info } from '../../assets/info.svg'
import axios from 'axios'
import { getHostName } from '../../base.js'
import COLORS  from '../../colors'

const useStyles = makeStyles((theme) => ({
	table: {
		width:'100%',
  	},
	input: {
	  	background: COLORS.gray,
	  	borderRadius: '2rem',
		margin: '1rem',
	},
	nameHead: {
		paddingTop:'0.6rem',
		paddingBottom:'0.6rem',
		padingRight: 0,
		paddingLeft: '1rem',
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
  	},
  	priceHead: {
		padding:0,
		paddingRight:'0.5rem',
		margin:0,
		color:'#5F6767',
		fontWeight: '500',
  	},
	addHead: {
		padding:0,
		paddingRight:'0.5rem',
		width: '10%',
		margin:0,
		color:'#5F6767',
		fontWeight: '500',    
  	},
  	nameBody: {
		padding:'1rem',
		color: COLORS.blue,
		fontWeight: '700',
		maxWidth: '45vw'   
  	},
  	priceBody:{
		padding:0,
		color: COLORS.green,
		fontWeight: '700',
  	},
	addBody: {
		padding:0,
		paddingLeft: '1rem'    
  	},
	articleBtn: {
		color:"#fff", 
		fontWeight:'bold', 
		backgroundColor:COLORS.blue, 
		textTransform:'none',
		marginLeft:'1rem',
		marginRight:'1rem',
		textDecoration:'none',
		"&:hover": {
			backgroundColor: COLORS.blue
	    } 
	}
  }));
 
const Articles = ({ cid, articleList, token, quantityNumber, lastItemAdded, cartItems }) => {
		const [ articles, setArticles ] = useState([])
		const [ article, setArticle ] = useState('');
		const [ isLoading, setIsLoading ] = useState(true)
		const [ searchArr, setSearchArr ] = useState([])
		const [ searchString, setSearchString ] = useState('')
		const [ popup, setPopup ] = useState(false)
		const [ isDisabled, setIsDisabled ] = useState(true)
		const [ info, setInfo ] = useState(false)
		const [ popupIsModalLogout, setPopupIsModalLogout ] = useState(false)
  		const { addItemToCart, changeLastItemQuantityNumber, setPageNumber, setPrevPage, setArticleList, signOut, resetPN } = useContext(AuthContext)
  		const classes = useStyles()
		const matches = useMediaQuery('(min-width:600px)')
		const navigate = useNavigate()
		const params = useParams()
		const [ width, setWidth ] = useState(window.innerWidth)
	    const [ height, setHeight ] = useState(window.innerHeight)

		useEffect(()=>{
			function hideKeypad(){
				  setWidth(window.innerWidth)
				  setHeight(window.innerHeight)	 	 
			}
			window.addEventListener('resize', hideKeypad, false)
			return () => window.removeEventListener('resize', hideKeypad, false)
	  	},[])

		// setup ref for your usage
		const myRef = useRef();
		const handlers = useSwipeable({ onSwipedLeft: () => handleLeftSwipe(), onSwipedRight: () => handleRightSwipe() })

		const handleLeftSwipe = () => {
				setPageNumber(null)
				navigate(`/kekspos/${params.tid}`)
		}

		const handleRightSwipe = () => {
			if(!isDisabled){
					setPageNumber(6)
					setTimeout(() => {
						navigate(`/kekspos/${params.tid}/kosarica`)	
					},0)
			}
		}
	
		const refPassthrough = (el) => {
				// call useSwipeable ref prop with el
				handlers.ref(el)
				// set myRef el so you can access it yourself
				myRef.current = el
		}
		  
		// back button logic
		useEffect(() => {
			setPrevPage({prevPageNum:5})
			window.addEventListener('popstate', onBackButtonEvent)
		
			return () => 
			{
					window.removeEventListener('popstate', onBackButtonEvent);
			}
	  	}, [])

		const onBackButtonEvent = (e) => {
				e.preventDefault()
	 			setPageNumber(null)	
				navigate(`/kekspos/${params.tid}`)
		}

		useEffect(() => 
        {   
            const handleReload = async (e) => 
            {
                e.preventDefault()
                signOut(cid)
                setTimeout(() => window.location.assign(`/kekspos`, 0));
                window.removeEventListener('beforeunload', handleReload) 
                return false
            }

            window.addEventListener("beforeunload", handleReload)
         
            return () => 
            {    
                window.removeEventListener('beforeunload', handleReload) 
            }
  
  	    }, [])
		
		const handleAddArticle = (item) => {
				console.log("potecial addition article to cart...", item.id)
				setArticle(item)
				setPopup(true)
  		}

		useEffect(() => {
			if(info){
				console.log("my last item: ", cartItems)
				if(cartItems.length!==0){
					let flag = false
					for(let ele of cartItems ){
					 	if(ele.item.id===lastItemAdded.item.id){   
					 			changeLastItemQuantityNumber({items:cartItems, item:lastItemAdded})
								flag=true
					 			break				 
					 		}
					}
					if(!flag){
						addItemToCart([...cartItems, lastItemAdded])
					}
				}else{
					addItemToCart([...cartItems, lastItemAdded])
				}
			}
			if(cartItems.length!==0){
					setIsDisabled(false)
			}
		},[info])

		const handlePopupClose = () => {
				setPopup(false)
				setInfo(true)
				setTimeout(function(){ setInfo(false) }, 1000)
		}

  		const handleSearch = (event) => {
			event.persist();
			setSearchString(event.target.value)
  		}

		useEffect(() => {
				setSearchArr(articles.filter( item => item.name.toLowerCase().includes(searchString.toLowerCase())))			 
		}, [searchString]);

		const getData = async () => {
			const config = {
				headers:{
				  'X-Session-Token':token
				}
			  };
            return await axios.get(getHostName() + '/article?tid=' + params.tid,config).then(response => {
                                    return response.data
            }).catch(error => {
									signOut(cid)
                                    console.log("Error happend while requesting the data...")
            })
      	}

      	useEffect(() => {
            if(articleList.length===0){
                  getData().then(apiData => {
						if(apiData.resultCode===0){
                        	setArticles(apiData.result)
                        	setArticleList(apiData.result)
							setTimeout(() => setIsLoading(false), 1000)
						}else{
							setTimeout(() => setIsLoading(false), 1000)
                            setPopupIsModalLogout(true)
						}
                                                
                  })
            }else{
                  setArticles(articleList)
                  setTimeout(()=>setIsLoading(false), 1000)
            }
      	},[])

		const handleName = (itemName) => {

			var newName = ""
			if(itemName.length>19)
			{
				newName = itemName.substring(0,19)+'...'
			}else
			{
				newName = itemName
			}
	
			return newName
		}

		const handleLogout = () => {
			setPopupIsModalLogout(false)
			setIsLoading(true)
			setTimeout(() => setIsLoading(false), 1000)
			resetPN()
			setTimeout(() => window.location.assign(`/kekspos`, 0))
	  }

	if(!isLoading){
  		return (
    	<div className="articles">
			<ModalAddArticle popup={popup}
							 quantityNumber={quantityNumber}
							 item={article} 
							 onAdd = {()=>handlePopupClose()}
							 onCancle = {()=>setPopup(false)}					 
			/>
			<ModalLogoutAlert popup={popupIsModalLogout} onClose={()=>handleLogout()} />
			<div className="articles-main" style={{zIndex:popup?'0':'1'}} {...handlers} ref={refPassthrough}>
				<div className="articles-header">
					<Header pageNumber={5}/>
					<div className="input-search">
						<TextField  variant="outlined"
							style={{width:!isMobile?'35rem':'100%'}}
							InputProps = {{
								className: classes.input,
							 	startAdornment: (
								<InputAdornment position="start">
									<IconButton>
										<Search />
									</IconButton>
								 </InputAdornment>
							 	)
							}}
							value={searchString}
							onChange={(event)=>handleSearch(event)}	  
			    		/>
					</div>
				</div>
				<div className="articles-body">
					<div className="articles-table" style={{height:isMobile?'55vh':'60vh'}}>
						<Table stickyHeader className={classes.table} aria-label="sticky table" size="small">
                        	<TableHead style={{zIndex:popup?'-1':'1'}}>
                            	<TableRow>
									{!isMobile&&<TableCell style={{width:'18%'}} component="td" scope="row"/>}
                                	<TableCell className={classes.nameHead}
												style={{width:!isMobile?'20%':'40%'}}  
												component="td" 
												scope="row"
									>Proizvod</TableCell>
                                	<TableCell className={classes.priceHead}
												style={{width:!isMobile?'32%':'30%'}} 
												component="td" 
												scope="row" 
												align="right"
									>Cijena</TableCell>
                                	<TableCell className={classes.addHead}
												style={{width:!isMobile?'10%':'15%'}}  
												component="td" 
												scope="row" 
												align="right"
									>Na račun</TableCell>
									{!isMobile&&<TableCell style={{width:'18%'}} component="td" scope="row"/>}
                            	</TableRow>
                        	</TableHead>
                        	<TableBody>
                            	{searchArr.length===0?(
                                	articles.map((item, id)=>
                                    	<TableRow key={id}>
											{!isMobile&&<TableCell component="td" scope="row"/>}
                                    		<TableCell className={classes.nameBody} 
                                                	component="td" 
                                                	scope="row" 
                                                    align="left"
                                        	><div style={{wordWrap:'break-word'}}>{item.name}</div></TableCell>
                                        	<TableCell className={classes.priceBody} 
														component="td" 
														scope="row" 
														align="right"
											>{item.price} EUR</TableCell>
                                        	<TableCell className={classes.addBody} 
														component="td" 
														scope="row" 
														align="right"
											><Button size="small" 
													variant="contained"
													style={{ width:'50%', 
															justifyContent:'center',
															cursor: 'pointer',
															color:"#fff", 
															fontWeight: 'bold', 
															backgroundColor: COLORS.blue, 
															textTransform: 'none'
															}}
													onClick={()=>handleAddArticle(item)}
												>DODAJ</Button>
                                        	</TableCell>
											{!isMobile&&<TableCell component="td" scope="row"/>}
                                    	</TableRow>) 
                                     ):(
                                searchArr.map((item, id) =>
                                    <TableRow key={id}>
											{!isMobile&&<TableCell component="td" scope="row"/>}
                                            <TableCell className={classes.nameBody} 
                                                        component="td" 
                                                        scope="row" 
                                                        align="left"
                                            ><div style={{wordWrap:'break-word'}}>{item.name}</div></TableCell>
                                            <TableCell className={classes.priceBody} 
														component="td" 
														scope="row" 
														align="right"
											>{item.price} EUR</TableCell>
                                            <TableCell className={classes.addBody} component="td" scope="row" align="right">
												<Button size="small" 
													variant="contained"
													style={{ width:'50%', 
															justifyContent:'center',
															cursor: 'pointer',
															color:"#fff", 
															fontWeight: 'bold', 
															backgroundColor: COLORS.blue, 
															textTransform: 'none'
															}}
													onClick={()=>handleAddArticle(item)}
												>DODAJ</Button>                  
                                            </TableCell>
											{!isMobile&&<TableCell component="td" scope="row"/>}
                                    </TableRow>)
                            )} 
                        	</TableBody>     
                    	</Table>
					</div>
					{height>500&&<div className="articles-footer-box" style={{zIndex:popup?'0':'1'}}>
						<div className="articles-footer" style={{top:!matches?'80vh':'80vh', width:!isMobile?'25rem':'90%'}}>
			 				{!info?(<div className="articles-status-box"><Info /><span>Ukupno proizvoda na računu: {quantityNumber}</span></div>):
						   	(<div className="articles-status-box-2"><div className="articles-status-box-2-txt"><Info /><span>{handleName(article.name)}</span>
						   											</div><div><span style={{ fontWeight:'700', color: COLORS.blue}}>{lastItemAdded.quantity}kom</span> - dodano na račun</div></div>)
							}
				 			<Button size="large" 
									variant="contained"
									disabled={isDisabled}
									component={Link}
									to={`/kekspos/${params.tid}/kosarica`}
									className={classes.articleBtn}
									onClick={()=>setPageNumber(6)}
							>NASTAVI</Button>
						</div>
					</div>}
				</div>
			</div>		
    	</div>
  	)
	}else{
		return(
			<div>
				<Loading />
			</div>
		)
	}	
}

export default Articles
